export default "__VITE_ASSET__bYDLWuju__"